import {GetterTree} from 'vuex'
import {WidgetState} from "@/apps/StudentExchangeInformationColumnWidget/models/store-viewmodel"
import {ILabels} from "@/apps/StudentExchangeInformationColumnWidget/models/config-viewmodel";

export default <GetterTree<WidgetState, WidgetState>>{
    getLabels(state): ILabels {
        return state.labels
    },
    getModalOpen(state): Boolean {
        return state.isModalOpen
    },
    getOffset(state): number {
        return state.offset
    }
}
